module.exports = __webpack_public_path__ + "img/73.9bc5e0d2.png";